import React, {createContext, useCallback, useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import PromptDialog from './PromptDialog';

export const PromptContext = createContext(promptDefinition => {});

export const PromptProvider = ({children}) => {
  const [portalDiv, setPortalDiv] = useState(null);
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    const div = window.document.createElement('div');
    window.document.body.appendChild(div);
    setPortalDiv(div);
    return () => window.document.body.removeChild(div);
  }, [setPortalDiv]);

  const clearPrompt = useCallback(() => setPrompt(null), []);

  return (
    <PromptContext.Provider value={[prompt, setPrompt]}>
      {portalDiv && prompt && createPortal(
        <PromptDialog prompt={prompt} clearPrompt={clearPrompt}/>,
        portalDiv
      )}
      {React.Children.only(children)}
    </PromptContext.Provider>
  );
};
